import { AnimatePresence, motion } from 'motion/react';

import CartItem from '@/components/SunrunShop/CartItem/CartItem';
import useSunrunShopStore from '@/data-store/hooks/useSunrunShopStore';

import useStyles from './Cart.styles';

export default function CartItems() {
  const { classes } = useStyles();
  const { cart } = useSunrunShopStore('cart');

  return (
    <div className={classes.cartItemContainer}>
      <AnimatePresence initial={false}>
        {cart?.lines.edges?.map((item) => (
          <motion.div
            key={item.node.id}
            initial={{ height: 0, opacity: 0, scale: 0 }}
            animate={{
              height: 'auto',
              opacity: 1,
              scale: 1,
              transition: { duration: 0.3, delay: 0.2, ease: 'easeOut' },
            }}
            exit={{ height: 0, opacity: 0, scale: 0 }}
            transition={{ duration: 0.3, ease: 'easeIn' }}
          >
            <CartItem item={item.node} cartId={cart.id} />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
